import React from 'react';
import MuiTypography from '@mui/material/Typography';
import { getEllipsisStyles } from './style';
import { ITypographyProps } from './type';
import { TypographyWithTooltip } from './TypographyWithTooltip';

export const Typography: React.FC<ITypographyProps> = ({
  children,
  maxWidth = '100%',
  sx,
  ellipsis = false,
  showTooltip = false,
  ...typographyProps
}) => {
  const renderTypography = () => (
    <MuiTypography
      sx={{
        ...(ellipsis && getEllipsisStyles(maxWidth)),
        ...sx,
      }}
      {...typographyProps}
    >
      {children}
    </MuiTypography>
  );

  if (showTooltip) {
    return (
      <TypographyWithTooltip
        maxWidth={maxWidth}
        sx={sx}
        ellipsis={ellipsis}
        {...typographyProps}
      >
        {children}
      </TypographyWithTooltip>
    );
  }

  return renderTypography();
};

export type { ITypographyProps } from './type';
export type { TypographyVariant } from '@mui/material/styles';
